const MetricCategoryItem = Object.freeze({
  OWNED: 'Owned',
  PARTNERED: 'Partnered',
  EARNED: 'Earned',
  TWITTER: 'Twitter',
  FACEBOOK: 'Facebook',
  INSTAGRAM: 'Instagram',
  YOU_TUBE: 'YouTube',
  TIKTOK: 'TikTok',
  OTHER: 'Other',
  NONE: 'None',
  POSITIVES: 'Positives',
  NEGATIVES: 'Negatives',
  NEUTRALS: 'Neutrals',
  MALE: 'Male',
  FEMALE: 'Female',
  UNKNOWN: 'Unknown',
  FIVE_STAR: 'FiveStar',
  FOUR_STAR: 'FourStar',
  THREE_STAR: 'ThreeStar',
  TWO_STAR: 'TwoStar',
  ONE_STAR: 'OneStar',
  TEN_SCORE: 'TenScore',
  NINE_SCORE: 'NineScore',
  EIGHT_SCORE: 'EightScore',
  SEVEN_SCORE: 'SevenScore',
  SIX_SCORE: 'SixScore',
  FIVE_SCORE: 'FiveScore',
  FOUR_SCORE: 'FourScore',
  THREE_SCORE: 'ThreeScore',
  TWO_SCORE: 'TwoScore',
  ONE_SCORE: 'OneScore',
  NO_SCORE: 'NoScore',
  PROMOTER: 'Promoter',
  PASSIVE: 'Passive',
  DETRACTOR: 'Detractor',
  NO_RESPONSE_STAR: 'NoResponseStar',
  NO_RESPONSE_SURVEY: 'NoResponseSurvey',
  NO_RESPONSE_NPS: 'NoResponseNPS',
  HIGH_SCORE: 'HighScore',
  MEDIUM_SCORE: 'MediumScore',
  LOW_SCORE: 'LowScore',
  SUM: 'Sum'
})
export default MetricCategoryItem
export type MetricCategoryItemStrings = typeof MetricCategoryItem[keyof typeof MetricCategoryItem]
// RESERVE BELOW
